namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.ExclusiveOffersDialog')
    export class ExclusiveOffersDialog extends Serenity.EntityDialog<ExclusiveOffersRow, any> {
        protected getFormKey() { return ExclusiveOffersForm.formKey; }
        protected getIdProperty() { return ExclusiveOffersRow.idProperty; }
        protected getLocalTextPrefix() { return ExclusiveOffersRow.localTextPrefix; }
        protected getNameProperty() { return ExclusiveOffersRow.nameProperty; }
        protected getService() { return ExclusiveOffersService.baseUrl; }
        protected getDeletePermission() { return ExclusiveOffersRow.deletePermission; }
        protected getInsertPermission() { return ExclusiveOffersRow.insertPermission; }
        protected getUpdatePermission() { return ExclusiveOffersRow.updatePermission; }

        protected form = new ExclusiveOffersForm(this.idPrefix);
    }
}